import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  const [subscribed, setSubscribed] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    setSubmitting(true);
    setError(null);
    try {
      const response = await fetch('https://formspree.io/f/xwvgyrgg', {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: new FormData(form)
      });
      if (!response.ok) {
        throw new Error('request failed');
      }
      form.reset();
      setSubscribed(true);
    } catch {
      setError('No pudimos completar tu suscripción. Intenta de nuevo.');
    } finally {
      setSubmitting(false);
    }
  };
  const quickLinks = ['Nosotros', 'Impacto', 'Equipo', 'Donar'];
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId.toLowerCase());
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="mp-footer bg-dark text-white py-12 px-4 sm:px-6 lg:px-8" data-id="element-66" data-mp="3v5deel4gkwps">
      <div className="max-w-6xl mx-auto" data-id="element-67" data-mp="3q7buxz34evds">
        <div className="mp-footer-grid grid md:grid-cols-4 gap-8 mb-8" data-id="element-68" data-mp="82qthw25bzvb">
          <div className="mp-footer-brand flex flex-col items-start text-left" data-id="element-69" data-mp="80nskgzggmbt">
            <img src="https://cdn.magicpatterns.com/uploads/mCLKNbkU7trnwa9R6xuSbK/3.png" alt="Pancita Feliz Foundation" className="mp-footer-logo brightness-0 invert" style={{
            width: '200px',
            height: 'auto',
            objectFit: 'contain',
            display: 'block',
            marginBottom: '16px',
            marginLeft: 0,
            marginRight: 'auto'
          }} data-id="element-70" data-mp="33nm44yp1hk6" />
            <p className="mp-footer-tagline text-sm text-gray-300" data-id="element-71" data-mp="tt07un1zcgow">
              Descubre • Conecta • Evoluciona
            </p>
          </div>

          <div className="mp-footer-newsletter" data-id="element-72" data-mp="13sr34qyd6zq1">
            <h3 style={{
            fontSize: '14px',
            fontWeight: 700,
            color: 'white',
            marginBottom: '16px'
          }} data-id="element-73" data-mp="13rzg44iu2abd">
              Mantente Informado
            </h3>
            <p style={{
            fontSize: '12px',
            color: 'rgba(255,255,255,0.6)',
            marginBottom: '16px'
          }} data-id="element-74" data-mp="1hjw7258rme66">
              Recibe noticias de la fundación y próximos eventos
            </p>
            {subscribed ? <p role="status" style={{
            fontSize: '13px',
            fontWeight: 600,
            color: '#7DC920'
          }} data-id="element-75" data-mp="3obx27dr50yve">
                ¡Gracias! Te mantendremos informado.
              </p> : <form onSubmit={handleSubscribe} style={{
            display: 'flex',
            gap: '8px'
          }} data-id="element-76" data-mp="25ncbk69rca65">
                <input type="email" name="email" required disabled={submitting} placeholder="Tu correo electrónico" aria-label="Tu correo electrónico" style={{
              padding: '10px 14px',
              borderRadius: '8px',
              fontSize: '13px',
              flex: 1,
              minWidth: 0,
              background: 'rgba(255,255,255,0.1)',
              color: 'white',
              border: '1px solid rgba(255,255,255,0.2)',
              outline: 'none'
            }} data-id="element-77" data-mp="1woi5zqeg89gg" />
                <button type="submit" disabled={submitting} style={{
              background: '#7DC920',
              color: 'white',
              padding: '10px 16px',
              borderRadius: '8px',
              fontSize: '13px',
              fontWeight: 600,
              border: 'none',
              cursor: submitting ? 'wait' : 'pointer',
              opacity: submitting ? 0.7 : 1,
              whiteSpace: 'nowrap'
            }} data-id="element-78" data-mp="2rvhffluoo770">
                  {submitting ? 'Enviando…' : 'Suscribir'}
                </button>
              </form>}
            {error && <p role="alert" style={{
            fontSize: '12px',
            color: '#ffb4b4',
            marginTop: '8px'
          }} data-id="element-79" data-mp="36j2jbhzduafz">
                {error}
              </p>}
            <p style={{
            fontSize: '11px',
            color: 'rgba(255,255,255,0.4)',
            marginTop: '8px'
          }} data-id="element-80" data-mp="1nl68xww6fjmm">
              Sin spam. Puedes cancelar cuando quieras.
            </p>
          </div>

          <div className="mp-footer-links" data-id="element-81" data-mp="1rnstrdufk4ab">
            <h3 className="font-bold mb-4" data-id="element-82" data-mp="1rouhahsmuj8x">Enlaces Rápidos</h3>
            <ul className="space-y-2" data-id="element-83" data-mp="13xgpccye8poh">
              {quickLinks.map(link => link === 'Donar' ? <li key={link} data-id="element-84" data-mp="zxemi0gx9q7m">
                    <Link to="/donar" className="text-gray-300 hover:text-primary transition-colors text-sm" data-id="element-85" data-mp="zy7t91fvsfpr">
                      {link}
                    </Link>
                  </li> : <li key={link} data-id="element-86" data-mp="l65zlz4emiy6">
                    <button onClick={() => scrollToSection(link)} className="text-gray-300 hover:text-primary transition-colors text-sm" data-id="element-87" data-mp="l54cuxe1080m">
                      {link}
                    </button>
                  </li>)}
            </ul>
          </div>

          <div className="mp-footer-social" data-id="element-88" data-mp="2q06vhjzjw30x">
            <h3 className="font-bold mb-4" data-id="element-89" data-mp="2q2jiwco2v5ld">Síguenos</h3>
            <div className="mp-footer-social-icons flex gap-4 mb-4" data-id="element-90" data-mp="2uyi1fjmq5tdv">
              <a href="#" className="hover:text-primary transition-colors" aria-label="Facebook" data-id="element-91" data-mp="1xc15oitn3nu8">
                <FacebookIcon className="w-6 h-6" data-id="element-92" data-mp="22b4co8t6k44u" />
              </a>
              <a href="https://www.instagram.com/pancita_feliz?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors" aria-label="Instagram" data-id="element-93" data-mp="278w1uv2fxc5c">
                <InstagramIcon className="w-6 h-6" data-id="element-94" data-mp="3mssily10ehb8" />
              </a>
            </div>
            <a href="mailto:info@pancitafelizfoundation.org" className="mp-footer-email" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginTop: '12px',
            fontSize: '14px',
            color: 'rgba(255,255,255,0.75)',
            textDecoration: 'none'
          }} data-id="element-95" data-mp="1b2ucelu8llls">
              <MailIcon size={16} color="rgba(255,255,255,0.75)" data-id="element-96" data-mp="sai6xq8ae47f" />
              info@pancitafelizfoundation.org
            </a>
          </div>
        </div>

        <div className="border-t border-gray-600 pt-8 text-center" data-id="element-97" data-mp="jczfo441utn3">
          <p className="text-sm text-gray-300" data-id="element-98" data-mp="edmqvdtmbchv">
            © {new Date().getFullYear()} Pancita Feliz Foundation Inc. Todos
            los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}